import type { Client } from "@/api/client.service";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
} from "@mui/material";

interface Props {
  open: boolean;
  onSelect: (client: Client) => void;
  clients: Client[];
}

export default function ClientSelectModal({
  open,
  onSelect,
  clients,
}: Props) {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: 4, maxWidth: 640 },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        Selecione um cliente
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Grid container spacing={2}>
          {clients.map((client, index) => {
            const isLastAndOdd = index === clients.length - 1 && clients.length % 2 !== 0;

            return (
              <Grid
                key={client.id}
                size={{ xs: 12, sm: isLastAndOdd ? 12 : 6 }}
                display="flex"
              >
                <Card
                  elevation={0}
                  sx={(theme) => ({
                    width: "100%",
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 3,
                    transition: theme.transitions.create(
                      ["transform", "box-shadow", "border-color"],
                      { duration: theme.transitions.duration.short }
                    ),

                    "&:hover": {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      boxShadow: theme.shadows[4],
                      transform: "translateY(-2px)",
                    },
                  })}
                >
                  <CardActionArea
                    onClick={() => onSelect(client)}
                    sx={{ height: "100%" }}
                  >
                    <CardContent>
                      <Typography variant="h6" fontWeight={600}>
                        {client.name}
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        mt={0.5}
                      >
                        {client.system_id}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            )
          })}
        </Grid>

        {clients.length === 0 && (
          <Box py={4} textAlign="center">
            <Typography color="text.secondary">
              Nenhum cliente disponível
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}